import { useRouter } from 'next/router';
import React from 'react';

import Button from 'components/Button/Button';
import RichText from 'components/RichText/RichText';
import {
  JoinUsPageType,
  OpportunitiesData,
} from 'containers/JoinUsPage/JoinUsPage.types';
import useOverElement from 'hooks/useOverElement';
import { useOpportunitiesStore } from 'store';
import {
  triggerDefaultCursor,
  triggerScaleUpCursor,
} from 'utils/cursorController';

import * as S from './JoinUsOpportunities.styles';

export interface JoinUsOpportunitiesProps {
  title: string;
  description: string;
  hoverTextColor?: string;
  hoverDefaultTextColors?: string;
  jobOverlay: {
    heading: string;
    location: string;
    department: string;
    type: string;
    level: string;
    socialsText: string;
    socialsToastText: string;
  };
  cta: {
    href: string;
    label: string;
  };
  socials: {
    title: string;
    type: string;
  };
  jobHeaders: {
    role: string;
    location: string;
    department: string;
  };
  opportunitiesData: OpportunitiesData;
  pageData: JoinUsPageType;
}

const defaultProps: Partial<JoinUsOpportunitiesProps> = {
  jobHeaders: {
    role: 'Role',
    location: 'Location',
    department: 'Department',
  },
};

const JoinUsOpportunities: React.FunctionComponent<
  JoinUsOpportunitiesProps
> = props => {
  const { openOpportunityList } = useOpportunitiesStore();
  const { push, pathname } = useRouter();

  const [ref] = useOverElement();

  const [ref1] = useOverElement();

  const [ref2] = useOverElement();

  const textColor = props.hoverTextColor ?? props.hoverDefaultTextColors;

  return (
    <>
      <S.Header ref={ref}>
        <S.Title>
          <RichText
            as="h3"
            size="heading3"
            richText={props.title}
            defaultFormatting
          />
        </S.Title>

        <RichText
          as="p"
          size="smallBody"
          richText={props.description}
          defaultFormatting
        />
      </S.Header>
      <S.Table ref={ref1}>
        <S.HeadRow>
          <S.Head>{props.jobHeaders.role}</S.Head>
          <S.Head>{props.jobHeaders.department}</S.Head>
          <S.Head>{props.jobHeaders.location}</S.Head>
          <S.Head></S.Head>
        </S.HeadRow>
        {props.opportunitiesData.opportunities
          .slice(0, 5)
          .map((opportunity, i) => (
            <S.Row
              key={`${opportunity.title}-${i}`}
              onMouseEnter={() => {
                triggerScaleUpCursor();
              }}
              onMouseLeave={() => {
                triggerDefaultCursor();
              }}
              onClick={() => {
                push(
                  `${pathname}?job=${opportunity.internal_job_id}`,
                  undefined,
                  { shallow: true }
                );
              }}
              textColor={textColor}
            >
              <S.Col>
                <p>{opportunity.title}</p>
              </S.Col>
              <S.Col>{opportunity.departments[0]}</S.Col>
              <S.Col>{opportunity.offices[0]}</S.Col>
              <S.Col>
                <S.IconWrapper>
                  <S.Icon />
                </S.IconWrapper>
              </S.Col>
            </S.Row>
          ))}
      </S.Table>
      <S.ButtonWrapper ref={ref2}>
        <Button label={props.cta.label} onClick={openOpportunityList} />
      </S.ButtonWrapper>
    </>
  );
};

JoinUsOpportunities.defaultProps = defaultProps;

export default JoinUsOpportunities;
